var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    !(_vm.isUsingNewLayout || ['de'].includes(_vm.$i18n.locale)) ||
    _vm.pageId !== 'ckv80nk6wekzd0d574mjqlkft'
  )?_c('nav',{staticClass:"nav nav--page",class:{
    'nav--scrollable-right': _vm.isScrollableRight,
    'nav--scrollable-left': _vm.isScrollableLeft,
  },attrs:{"data-type":"PageNavigation"}},[_c('div',{ref:"navigationBar",staticClass:"wrapper",class:[
      {
        'wrapper-xxl navigation-modern': _vm.isUsingNewLayout,
        fixed: _vm.isFixed,
      } ]},[_c('ul',{ref:"navItemWrapper"},[_vm._l((_vm.items),function(item,index){return [_c('li',{key:'nav-item-' + index,staticClass:"nav__item"},[_c('NuxtLink',{attrs:{"to":{
              hash: '#' + _vm.$slugify(item.title || item, { lower: true }),
            }}},[_vm._v("\n            "+_vm._s(item.title || item)+"\n          ")])],1),_vm._v(" "),(index != _vm.items.length - 1 && !_vm.isUsingNewLayout)?_c('li',{key:'nav-seperator-' + index,staticClass:"nav__seperator"}):_vm._e()]})],2)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }